module.exports = __webpack_public_path__ + "placa_infor_10x_s_entr_s_juros.png?f4aa00ab70bb34e46d3b4c1177463f8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_infor_10x_s_entr_s_juros.png
// module id = 124
// module chunks = 0